import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { CREATE_ENTITY_REQUEST_CONFIG } from '../config/create-entity-widget-config.types';
import { isSecureRequestUrl, isUsableAccessToken, isUsableEventSource } from '../shared/credentials.util';

/**
 * Attaches `Authorization: Bearer <token>` and `jemma-event-source` to the
 * calls a Jemma API service method stamped with `CREATE_ENTITY_REQUEST_CONFIG`.
 * Requests with no config attached pass through unchanged.
 *
 * Fails closed: a stamped request whose token or event source is unusable, or whose URL is not
 * HTTPS never leaves the browser. The token is read from the config and never
 * logged or stored.
 */
export const createEntityAuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const _config = req.context.get(CREATE_ENTITY_REQUEST_CONFIG);

    if (!_config) {
        return next(req);
    }

    if (!isUsableAccessToken(_config.accessToken) || !isUsableEventSource(_config.eventSource) || !isSecureRequestUrl(req.url)) {
        return throwError(
            () =>
                new HttpErrorResponse({
                    status: 0,
                    statusText: 'Create-entity request blocked: no usable bearer token or event source, or insecure URL.',
                    url: req.url
                })
        );
    }

    return next(
        req.clone({
            setHeaders: {
                Authorization: `Bearer ${_config.accessToken}`,
                'jemma-event-source': _config.eventSource
            }
        })
    );
};
